import { render, staticRenderFns } from "./createShopee.vue?vue&type=template&id=3258eaf3&scoped=true"
import script from "./createShopee.vue?vue&type=script&lang=js"
export * from "./createShopee.vue?vue&type=script&lang=js"
import style0 from "./createShopee.vue?vue&type=style&index=0&id=3258eaf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3258eaf3",
  null
  
)

export default component.exports